// import { fetchStart, fetchSuccestorage } from '../../../redux/actions';
import React from 'react';
import { setAuthUser } from '../../../redux/actions/Auth';
import storage from '../../utils/localStorage';

const BasicAuth = {
	onLogout: () => (dispatch) => {
		storage.setItem('user', null);
		dispatch(setAuthUser(null));
		location.reload();
	},

	getAuthUser: () => (dispatch) => {
		const token = window.location.hash.substr(1)?.split('=')?.[1];

		if (token) {
			storage.setItem('user', { token });
			dispatch(setAuthUser({ token }));
		} else {
			dispatch(setAuthUser(storage.getItem('user')));
		}
	},

	getSocialMediaIcons: () => <> </>,
};

export default BasicAuth;
